import { ClockifyTimeEntriesResponse } from "./ClockifyTimeEntriesResponse";
import { ClockifyTimeEntry } from "./ClockifyTimeEntry";
export class ClockifyTimeEntriesReportMapper {
  mapClockifyTimeEntriesResponseToClockifyTimeEntry = (
    response: ClockifyTimeEntriesResponse
  ): ClockifyTimeEntry => {
    return {
      id: response.id,
      clockifyId: response.clockifyId,
      gitLabTaskId: response.gitLabTaskId,
      description: response.description,
      taskTimeBudget: response.taskTimeBudget,
      developerName: response.developerName,
      milestoneId: response.milestoneId,
      milestoneTaskId: response.milestoneTaskId,
      timeSpentInHours: response.timeSpentInHours,
      totalSpentTimeOnTaskInHours: response.totalSpentTimeOnTaskInHours,
      percentageComplete: response.percentageComplete,
      dateStart: response.dateStart,
      dateEnd: response.dateEnd,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
      typeOfWork: response.typeOfWork,
    };
  };
}
